"use strict";

var _slicedToArray = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var R = __importStar(require("ramda"));

var PermissionsContext_1 = require("./PermissionsContext");

var isAllowed_1 = require("./isAllowed");

var IfAllowed = function IfAllowed(_ref) {
  var children = _ref.children,
      permissions = _ref.permissions;
  var context = react_1.useContext(PermissionsContext_1.PermissionsContext);
  var allowed = true;
  var result;
  result = permissions.map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 3),
        type = _ref3[0],
        resource = _ref3[1],
        permission = _ref3[2];

    return {
      allowed: isAllowed_1.isAllowed({
        permission: permission,
        resource: resource,
        type: type
      }, context.permissions),
      fields: R.pathOr({}, [type, resource, 'permission', permission, 'fields'], context.permissions)
    };
  });
  allowed = R.all(R.propEq('allowed', true), result);

  if (typeof children === 'function') {
    return children(allowed, result);
  }

  return allowed ? children : null;
};

exports.IfAllowed = IfAllowed;